/**
 * Event toggle functionality
 * 
 *    Open and close event details (without navigation to separate event page)
 *    with a mouse click.
 * 
 */

(function(){
  var events_widget_element = document.querySelector('.events-embed-container');
  console.log(events_widget_element);
  //var events_listing_upcoming = document.querySelector('.events-listing-upcoming');
  //var events_listing_past = document.querySelector('.events-listing-past');
  if (!events_widget_element) {
    return;
  }

  function createToggleHandler(target) {
    return function() {
      if (target.classList.contains('active')) {
        target.classList.remove('active');
      } else {
        target.classList.add('active');
      }
    };
  }

  if (events_widget_element) {
    var rows = events_widget_element.getElementsByClassName('event-row');
    for (var i = 0; i < rows.length; i++) {
      var event_element = rows[i];
      event_element.addEventListener('click', createToggleHandler(event_element));
    }
  }

  // if (events_listing_upcoming) {
  //   var rows2 = events_listing_upcoming.getElementsByClassName('event-row');
  //   for (var i = 0; i < rows2.length; i++) {
  //     var event_element = rows2[i];
  //     event_element.addEventListener('click', createToggleHandler(event_element));
  //   }
  // }

  // if (events_listing_past) {
  //   var rows3 = events_listing_past.getElementsByClassName('event-row');
  //   for (var i = 0; i < rows3.length; i++) {
  //     var event_element = rows3[i];
  //     event_element.addEventListener('click', createToggleHandler(event_element));
  //   }
  // }

  

  
}());
